import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import {getSectionColor, getSectionImage, getAltText} from "../assets/settings";

class ScrollSection extends React.Component {
    constructor() {
        super();
        this.doReportSize = true;
        this.lastTop = -1;

    }

    componentDidMount() {
        const {store, sectionKey} = this.props;
        this.sectionStore = store.createSection(sectionKey);
    }

    componentDidUpdate() {
        this.updateSectionData(this.elementRef.getBoundingClientRect());

    }

    updateSectionData(rect) {
        if (!this.sectionStore) return;
        const {store, sectionGroup, sectionKey, sectionY} = this.props;

        if (this.lastTop === rect.top) return;

        // if (!this.doReportSize) return;
        let scrollProgress = 0;
        let visible = false;
        const anchorY = document.documentElement.clientHeight * sectionY;
        if (rect.top + rect.height> 0 && rect.top < document.documentElement.clientHeight) {
            scrollProgress = (anchorY-rect.top) / rect.height;
            visible = true;
        }
        if (rect.bottom < 0) {
            scrollProgress = 1;//complete
        }
        if (visible && scrollProgress >= 0 && scrollProgress < 1) {
            store.setActiveSection(sectionGroup, sectionKey);
        }
        this.sectionStore.setVisible(visible);
        this.sectionStore.setScrollProgress(scrollProgress);
        // this.doReportSize = false;
        this.lastTop = rect.top
    }

    setElem(r) {
        this.elementRef = r;
        if (r) {
            this.updateSectionData(this.elementRef.getBoundingClientRect());
        }
    }

    render() {
        const {height, background, children, sectionKey, store, sectionGroup} = this.props;
        // console.log(this.props);
        const imageIfMobile = () => {
            if (store.interactionsStore.mobileMode && sectionGroup !== 'main') {
                return <div className={'mobile-mode-img'} style={{backgroundColor:getSectionColor(sectionGroup)}}>
                    {getAltText(sectionKey).title && <h4 style={{'backgroundColor': getSectionColor(sectionGroup) + '80'}}>{getAltText(sectionKey).title}</h4>}
                    <img width={'100%'} src={getSectionImage(sectionGroup, sectionKey)}/>
                </div>
            }
        };

        if (children) {

            return (
                <div id={`section_${sectionKey}`} ref={(r) => this.setElem(r)} className={'ScrollSection'}
                     style={{height, background}}>
                    {children}
                    {imageIfMobile()}
                </div>
            );
        }
        return (
            <div id={`section_${sectionKey}`} ref={(r) => this.setElem(r)} className={'ScrollSection'}
                 style={{height, background}}/>
        );
    }
}

ScrollSection.defaultProps = {
    sectionY: 0.5
};
export default observer(ScrollSection);
